/*
    Some shared js functions
*/

var faLoadjQueryThenRun = function (callback) {
  
    // Part of load in jQuery
    var faLoadScript = function (url, callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";

      // If the browser is Internet Explorer.
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == "loaded" || script.readyState == "complete") {
            script.onreadystatechange = null;
            callback();
          }
        };
        // For any other browser.
      } else {
        script.onload = function () {
          callback();
        };
      }

      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    };

    if (!window.jQuery) {
        // If jQuery isn't load, then we have to load one by ourselves.
        // 1. We preserve a copy of jquery in assets folder based on Shopify assets loading best practice
        // 2. Based on https://api.jquery.com/jquery.noconflict/, we use jQuery.noConflict(false) to create a new jQuery
        //    `false`: A Boolean indicating whether to remove all jQuery variables from the global scope (including jQuery itself).
        faLoadScript("//b2b.figuredart.co.uk/cdn/shop/t/4/assets/jquery-3.6.1.min.js?1774", () => callback(jQuery.noConflict(false)));
    } else {
        // Use the loaded jQuery
        callback(window.jQuery);
    }
};